import React from "react";
import Content from "../content/Content";
import ContentHead from "../content/ContentHead";
import ContentBody from "../content/ContentBody";
import Table from "../table/table";
import TableLoading from "../tableLoading/TableLoading";

function WithTableView(props) {
  return (
    <Content>
      <ContentHead
        title={props.heading}
        showBtn1={props.show_btn_1 ? props.show_btn_1 : false}
        btn1Name="btn1"
        btn1Text={props.btn1Text ? props.btn1Text : ""}
        btn1type={props.btn1Type ? props.btn1Type : undefined}
        onClickHandler={props?.onClickHandler ? props.onClickHandler : ""}
        isIcon={props?.isIcon}
        iconType={props?.iconType}
        customElement={props?.customElement}
      />
      <ContentBody style={{ padding: 0 }}>
        {props.loading ? (
          <TableLoading head={[...props.head]} />
        ) : (
          <Table
            head={[...props.head]}
            filtervalue={props.filtervalue}
            body={props.body}
            body_keys={[...props.body_keys]}
            number={true}
            onActionClick={props.onActionClick}
            onCloneClick={props?.onCloneClick}
            onRowClick={props.onRowClick}
            onRemarksSave={props.onRemarksSave}
            handleDropdownUpdate={props.handleDropdownUpdate}
            dropdownValues={props.dropdownValues}
            page={props?.page}
            showIconAt={props?.showIconAt}
            icon={props?.icon}
            onHeadClick={props?.onHeadClick}
          />
        )}
      </ContentBody>
    </Content>
  );
}

export default WithTableView;
